import { render, staticRenderFns } from "./matchList.vue?vue&type=template&id=30794c8f&scoped=true&"
import script from "./matchList.vue?vue&type=script&lang=js&"
export * from "./matchList.vue?vue&type=script&lang=js&"
import style0 from "./matchList.vue?vue&type=style&index=0&id=30794c8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30794c8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30794c8f')) {
      api.createRecord('30794c8f', component.options)
    } else {
      api.reload('30794c8f', component.options)
    }
    module.hot.accept("./matchList.vue?vue&type=template&id=30794c8f&scoped=true&", function () {
      api.rerender('30794c8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/match/matchList.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/match/matchList.vue
// module id = TQ9Z
// module chunks = 0